// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@sc/App/GoogleAnalyticsConnector/Store/Reducers";
import { getDataLayer } from "@sc/App/GoogleAnalyticsConnector/Utilities/DataLayer";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    ExecuteOnSuccessCallback,
} from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/CreateOrRequestQuote";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { parseProductCategories } from "@sc/XDL/Utilities";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

const _GaDispatchRequestAQuote: typeof ExecuteOnSuccessCallback = props => {
    const state = props.getState() as xGoogleAnalyticsState;

    if (!state.xGoogleAnalytics.requestAQuoteEvent) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const session = getSession(state);
    const cart = getCurrentCartState(state).value;

    if (!cart || !cart.cartLines || cart.cartLines.length === 0) {
        return;
    }


    const googleAnalyticsData = {
        event: state.xGoogleAnalytics.requestAQuoteEventName,
        page_path: getLocation(state).pathname,
        affiliation: state.xGoogleAnalytics.affiliation || "",
        sales_rep: state.xGoogleAnalytics.salesRep || "",
        is_rep: state.xGoogleAnalytics.isRep || "",
        bill_to_num: state.xGoogleAnalytics.billToNum || "",
        ship_to_num: state.xGoogleAnalytics.shipToNum || "",
        cust_type: state.xGoogleAnalytics.customerType || "",
        login_type: state.xGoogleAnalytics.loginType || "",
        warehouse: state.xGoogleAnalytics.warehouse || "",
        items: cart.cartLines.map((cartLine, idx) => ({
            item_id: cartLine.erpNumber,
            item_name: cartLine.shortDescription || cartLine.productName,
            affiliation: state.xGoogleAnalytics.affiliation || "",
            discount: cartLine.pricing
                ? cartLine.pricing.unitNetPrice < cartLine.pricing.unitListPrice
                    ? cartLine.pricing.unitListPrice - cartLine.pricing.unitNetPrice
                    : 0
                : 0,
            index: idx,
            item_brand: state.xGoogleAnalytics.includeProductBrand ? cartLine.brand?.name || "" : undefined,
            price: cartLine.pricing?.unitNetPrice,
            quantity: cartLine.qtyOrdered,
            item_list_id: state.xGoogleAnalytics.includeProductCategory
                ? cartLine.properties?.["categoriesIds"] || ""
                : undefined,
            location_id: session.pickUpWarehouse?.id,
            ...parseProductCategories(
                cartLine?.properties?.itemCategoriesShortDescription,
                true,
                state.xGoogleAnalytics.includeProductCategory,
            ),
        })),
    };

    dataLayer.push({ ecommerce: null });
    dataLayer.push(googleAnalyticsData);
};

addToChainAfter(chain, ExecuteOnSuccessCallback, _GaDispatchRequestAQuote);
